import { isNil } from "@s-libs/micro-dash";

export const GRADES = [...Array(13).keys()];

export const itemToString = (item) =>
  isNil(item) ? "" : `Grade ${item === 0 ? "KG" : item}`;

export const getLowestGradeError = ({ lowest }) => {
  if (isNil(lowest)) return "Select the lowest grade taught";
};

export const getHighestGradeError = ({ lowest, highest }) => {
  if (isNil(highest)) return "Select the highest grade taught";
  if (lowest > highest)
    return "The grade must be equal to or greater than the one selected in the lowest grade taught field";
};

export const isValidGradeRange = (grades, touched) => {
  const isValidFields =
    !getLowestGradeError(grades) && !getHighestGradeError(grades);
  return isValidFields || !touched;
};
